<template id="main-page">
  <v-ons-page>
  <img src="../../../public/logo.png" alt="Nature" class="responsive">
  <v-ons-card>
  <div class="content">
    <p style="text-align: center; padding-left: 3%">
    <v-ons-input placeholder="Nome de Usuário" float v-model="username"/>
    </p>
    <p style="text-align: center; padding-left: 3%">
    <v-ons-input placeholder="Senha" type="password" float v-model="password"/>
    </p>
    <p style="text-align: center; padding-left: 3%">
    <v-ons-button style="margin: 6px 0" @click="login()">Entrar</v-ons-button>
    </p>
  </div>
  </v-ons-card>
  </v-ons-page>
</template>

<style>
.responsive {
  width: 90%;
  height: auto;
  padding: 5%;


}
</style>

<script>
      export default {
        data() {
          return {
            username: "",
            password: "",
          };
        },
        methods: {
          login: function() {
            let username = this.username;
            let password = this.password;
            this.$store
              .dispatch("login", { username, password })
              .then(() =>
               this.$router.push("/"),
               )
              .catch(err => console.log(err));
          }
        }
      };
</script>